import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useQuery } from 'react-query';
import { useAuth } from '../auth/AuthContext';
import { getLegalStatus } from '../api/developerApi';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  const { data: legalStatus, isLoading: legalLoading } = useQuery(
    'legal-status',
    getLegalStatus,
    {
      enabled: !!user,
      staleTime: 60 * 1000, // re-check after 1 minute
      retry: 1,
    }
  );

  if (loading || (user && legalLoading)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress sx={{ color: '#3B82F6' }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Gate: ToS must be accepted before accessing any authenticated route.
  // Skip the gate if already on /legal/accept to avoid redirect loop.
  if (legalStatus && !legalStatus.tosAccepted && location.pathname !== '/legal/accept') {
    return <Navigate to="/legal/accept" replace />;
  }

  return children;
}
